import React from 'react'
import { Table, Th, Td, Tr, Badge } from '@/shared/ui'

function iso(v?: string | null) { return v ? new Date(v).toLocaleString() : '-' }

export default function ReferredAccountsTable({ rows }: { rows: Array<{ account_id: string; account_name?: string|null; created_at?: string|null; subscription_status?: string|null; current_period_end?: string|null }> }) {
  return (
    <Table>
      <thead>
        <Tr><Th>Conta</Th><Th>Criada em</Th><Th>Status</Th><Th>Próx. ciclo</Th></Tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <Tr key={r.account_id}>
            <Td>{(function(){ const name=(r.account_name||''); const id=r.account_id; const parts=String(name).trim().split(/\s+/).filter(Boolean); if(parts.length===0){ const f=String(id||''); return f ? (f.slice(0,4)+'...'+f.slice(-4)) : '-' } const first=parts[0]; const last=parts.length>1?parts[parts.length-1]:parts[0]; const left=first.slice(0, Math.min(4, first.length)); const right=last.slice(-Math.min(4, last.length)); return left+'... ...'+right })()}</Td>
            <Td>{iso(r.created_at || undefined)}</Td>
            <Td><Badge variant="soft" className="capitalize">{r.subscription_status || '-'}</Badge></Td>
            <Td>{iso(r.current_period_end || undefined)}</Td>
          </Tr>
        ))}
        {rows.length === 0 && (<Tr><Td colSpan={4} className="py-6 text-center text-sm text-foreground/70">Sem afiliações ainda.</Td></Tr>)}
      </tbody>
    </Table>
  )
}

